export function resolveAppEnv(): string {
  const explicit = process.env.EXPO_PUBLIC_ENV;
  if (explicit && explicit.length > 0) {
    return explicit;
  }
  const isDev = (globalThis as { __DEV__?: boolean }).__DEV__ ?? false;
  return isDev ? 'development' : 'production';
}
